<template>
    <div class="slide" :class="{first_slide}">
        <div class="slide_inner">
            <div class="backgrounds_wrapper" v-if="first_slide">
                <div class="background background_1" data-aos="fade-up" data-aos-duration="2000" data-aos-delay="200"></div>
                <div class="background background_2" data-aos="fade-up" data-aos-duration="2000" data-aos-delay="200"></div>
                <div class="background background_3" data-aos="fade-up" data-aos-duration="2000" data-aos-delay="200"></div>
                <div class="background background_4" data-aos="fade-right" data-aos-duration="2000" data-aos-delay="200"></div>
            </div>
            <div class="slide_content grid-container" v-if="first_slide">
                <div class="twenties">
                    <div class="line" data-aos="fade-in" data-aos-duration="2000" data-aos-delay="200">
                        <div class="num">20</div>
                        <div class="text">уголовных дел</div>
                    </div>
                    <div class="line" data-aos="fade-in" data-aos-duration="2000" data-aos-delay="200">
                        <div class="num">20</div>
                        <div class="text">-тилетия</div>
                    </div>
                </div>
                <div class="mouse_hint"></div>
            </div>
            <div class="slide_content grid-container" v-if="!first_slide">
                <svg width="40" height="710" class="case_type">
                    <text x="355" y="40" transform="translate(40) rotate(90 0 0)">{{ content.type == 1 ? 'Чиновники' : 'Бизнес' }}</text>
                </svg>
                <div class="grid-x grid-margin-x">
                    <div></div>
                    <div class="cell small-12 medium-5 large-4" style="position:relative">
                        <div class="case_slider">
                            <ImgSlider v-if="content.slider.length" :slides=content.slider />
                        </div>
                        <div class="case_header">
                            <header>{{ content.title }}</header>
                            <h3 v-if="content.subtitle">{{ content.subtitle }}</h3>
                            <router-link :to="`/cases/${ content.id - 1 }`" class="button read_more">Узнать больше</router-link>
                        </div>
                    </div>
                    <div class="cell small-12 medium-7 large-8">
                        <div class="grid-x grid-margin-x">
                            <div class="cell medium-9 large-10">
                                <img :src="content.image" :alt="content.title">
                                <div class="year">
                                    <button type="button" v-if="navigation.next" @click="goToNext" class="arr next"></button>
                                    <button type="button" v-if="navigation.prev" @click="goToPrev" class="arr prev"></button>
                                    {{ navigation.year }}
                                    <span v-if="navigation.month">{{ navigation.month }}</span>
                                </div>
                            </div>
                            <div class="cell medium-3 large-2 img_desc">
                                {{ content.description }}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import AOS from 'aos'
    import ImgSlider from '../components/ImageSlider'

    export default {
        name: 'slide',
        props: {
            content: {required:true, default:{} },
            slideIdx: { required:true },
            slidesNum: { required:true }
        },
        components: { ImgSlider },
        data: () => ({
            first_slide:false
        }),
        computed: {
            navigation(){
                let splitDate = this.content.year.split(', ')
                let year = splitDate[0],
                    month = splitDate[1] ? splitDate[1] : false,
                    prev = this.slideIdx != 0 ? `/slides/${this.slideIdx-1}` : false,
                    next = this.slideIdx < this.slidesNum-1 ? `/slides/${this.slideIdx+1}` : false
                return { year, month, prev, next }
            }
        },
        created(){
            this.first_slide = this.content.type == 0
        },
        mounted(){
            AOS.init()
        },
        methods: {
            goToPrev(){ this.$root.$emit('goToPrev', { slideIdx:this.slideIdx }) },
            goToNext(){ this.$root.$emit('goToNext', { slideIdx:this.slideIdx }) }
        }
    }
</script>

<style lang="scss">
    .slide {
        position:absolute; display:none; width:200vw; height:200vh; left:-50vw; top:-50vh; /*transition:opacity .1s ease;*/ transform:translate3D(0,0,0); opacity:1; will-change:opacity; background-color:$purple;
        .case_slider:after { background-color:$purple }
        &:nth-child(2n) {
            background-color:$purple-gray;
            .case_slider:after { background-color:$purple-gray }
        }

        &.out { display:none }

        .slide_inner {
            position:absolute; width:100vw; height:100vh; left:50vw; top:50vh;

            .slide_content {
                display:flex; flex-direction:column; justify-content:center; height:100%; padding:$space*2 $space $space; color:#fff;

                .case_type {
                    position:absolute; left:0; top:50%; transform:translateY(-50%); left:-8px; opacity:.7;
                    text {font-size:3rem; text-transform:uppercase; fill:transparent; stroke:#fff; stroke-width:2px; font-family:$gorod; text-anchor:middle;
                    }
                }

                .case_slider {
                    position:relative; width:90%; margin-top:$space*2;
                    &:empty { display:none }
                    &:before, &:after { content:""; position:absolute; width:90%; height:100%; border:2px solid #6d6a6e; top:0; right:0 }
                    &:after { right:10px; top:10px }
                    .carousel {
                        position:relative; width:90%; height:90%; transform:translate(13px, 20px); z-index:1; border:2px solid #6d6a6e;
                        
                        img { display:block; width:100%; }
                    }

                }

                .case_header {
                    position:relative; z-index:1; transform:translateX(20%); width:120%; font-family:$sans-serif;padding-top:$space*3;
                    
                    header { font-size:fsz(3.5rem); font-weight:900; line-height:1 }
                }

                .read_more {
                    background:$yellow; text-transform:uppercase; font-family:$sans-serif; font-weight:bold; color:#211d23; font-size:fsz(.9rem); padding:$space $space*2; margin-top:$space*2; 
                }

                .img_desc { font-size:.8rem }

                .year {
                    font-size:fsz(3rem); font-family:$gorod; position:relative; display:inline-block; transform:translate(160%, -50%); padding:30px 0;
                    span { position:absolute; right:68%; top:74%; font-size:1.3rem; color:transparent; -webkit-text-stroke:1px #fff; text-align:right; line-height:1.15 }

                    .arr {
                        position:absolute; left:50%; transform:translateX(-50%); width:0; height:0; border-style:solid; cursor:pointer;
                        &:focus { outline:none }
                        &.next { top:8%; border-width:0 25px 20px 25px; border-color:transparent transparent $yellow transparent; animation:year_arrow_top 4s ease 0s infinite }
                        &.prev { bottom:8%; border-width:20px 25px 0 25px; border-color:$yellow transparent transparent transparent; animation:year_arrow_bottom 4s ease 0s infinite }
                    }

                    &:hover {
                        .arr {
                            animation-play-state:paused;
                        }
                        
                    }

                    @keyframes year_arrow_top {
                        0%, 10%, 20%, 40%, 100% { top:8% }
                        5% { top:4% }
                    }

                    @keyframes year_arrow_bottom {
                        0%, 10%, 20%, 40%, 100% { bottom:8% }
                        5% { bottom:4% }
                    }
                }
            }

            h2 { font-size:calc(10vh + 1vw); text-transform:uppercase; line-height:.9; margin-bottom:$space*2; font-family:serif; font-weight:bold}
        }

        &.first_slide {
            background-color:#1b0e1f!important;

            .backgrounds_wrapper { opacity:.7 }
            .background {
                width:100%; height:100%; background-repeat:no-repeat; position:absolute; background-size:50%;
                &.background_1 { background-image:url('~@/./assets/img/background_1.png'); background-size:40%; background-position:0% 120%; }
                &.background_2 { background-image:url('~@/./assets/img/background_2.png'); background-position:45% 100%; z-index:1 }
                &.background_3 { background-image:url('~@/./assets/img/background_3.png'); background-size:40%; background-position:94% 115%; }
                &.background_4 { background-image:url('~@/./assets/img/background_4.png'); background-size:20%; background-position:35% 10%; }
            }

            .mouse_hint {
                position:absolute; z-index:2; left:50%; bottom:$space*2; transform:translateX(-50%); width:30px; height:60px; background-image:url('~@/./assets/img/icon_mouse.png'), url('~@/./assets/img/icon_mouse_triangle.png'); background-repeat:no-repeat, no-repeat; background-position:50% 0, 50% 92%; background-size:30px, 18px; animation:mouse_arrow 2s ease 0s infinite; transition:left .2s ease;

                @keyframes mouse_arrow {
                    0%, 20%, 40%, 100% { background-position:50% 0, 50% 92% }
                    10% { background-position:50% 0, 50% 100% }
                }

                &:hover { left:45%; width:180px; transition:left .2s ease }
            }

            .twenties {
                font-family:$gorod; line-height:1; color:#fff; letter-spacing:2px; font-size:fsz(3rem); transform:translateY(10%); z-index:2; font-size:calc(3.25vw + 0.25vh);
                
                .line {
                    position:relative; z-index:2; pointer-events:none;
                    .num { color:$golden; font-size:fsz(10rem); letter-spacing:20px; margin-bottom:$space; opacity:.8 }
                    .text { position:absolute; top:44%; top:calc(50% - #{$space}); left:38%; z-index:2; }

                    &:nth-child(1){
                        .text { top:calc(32% - #{$space}) }
                    }
                    &:nth-child(2){
                        .text { left:37% }
                    }
                }
            }    
        }
    }
</style>